import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Col, Modal, ModalHeader, ModalBody, Row } from "reactstrap";
import { UpdateOrganizationDetails } from "services/OrganizationServices";
import { UpdateOrgSPOCDetails } from "services/OrganizationSPOCServices";
import cross from "../../../assets/images/icon/cross.svg";
const EditSPOCModal = ({
  t,
  editSPOCDetails,
  setEditSPOCDetails,
  editModal,
  setEditModal,
  fetchData,
  ...props
}) => {
  const [errors, setErrors] = useState({});

  const toggleEditModal = () => {
    if (!!editModal) {
      setEditSPOCDetails({});
    }

    setEditModal(!editModal);
    setErrors({});
  };

  const validateFields = () => {
    let errors = {};
    
    if (!editSPOCDetails?.name?.trim()) {
      errors.name = t("Organization.SPOC.Name is required");
    } else if (!/^[A-Za-z\s]+$/.test(editSPOCDetails.name.trim())) {
      errors.name = t("Organization.SPOC.Name should contain only alphabets and spaces");
    }
    if (!editSPOCDetails?.email_id?.trim()) {
      errors.email_id = t("Organization.SPOC.Email is required");
    } else if (!/^\S+@\S+\.\S+$/.test(editSPOCDetails.email_id.trim())) {
      errors.email_id = t("Organization.SPOC.Enter a valid email");
    }

    if (!editSPOCDetails?.mobile_no?.trim()) {
      errors.mobile_no = t("Organization.SPOC.Mobile number is required");
    } else if (!/^\d{10}$/.test(editSPOCDetails.mobile_no.trim())) {
      errors.mobile_no = t("Organization.SPOC.Enter a valid mobile number (10 digits)");
    }
    else if (/^0{10}$/.test(editSPOCDetails.mobile_no.trim())) {
      errors.mobile_no = t("Organization.SPOC.Enter a valid mobile number (10 digits)");
    }

    if (!editSPOCDetails?.role?.trim()) {
      errors.role = t("Organization.SPOC.Role is required");
    } else if (!/^[A-Za-z\s]+$/.test(editSPOCDetails.role.trim())) {
      errors.role = t("Organization.SPOC.Role should contain only alphabets and spaces");
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSaveClick = async () => {
    if (!validateFields()) {
      setTimeout(() => setErrors({}), 2500);
      return;
    }

    try {
      let reqBody = {
        name: editSPOCDetails?.name?.trim(),
        email_id: editSPOCDetails?.email_id?.trim(),
        mobile_no: editSPOCDetails?.mobile_no?.trim(),
        role: editSPOCDetails?.role?.trim(),
      };

      let response = await UpdateOrgSPOCDetails(editSPOCDetails?.id, reqBody);
      let responseMsg = response?.data?.message || "SPOC Updated Successfully";
      toast.success(responseMsg);

      setTimeout(() => {
        toggleEditModal();
        fetchData({});
      }, 1000);
    } catch (error) {
      let errMsg = error?.response?.data?.message || "Error while updating spoc";
      let errors = error?.response?.data?.errors || {};
      setErrors(errors);
      setTimeout(() => setErrors({}), 2500);
      toast.error(errMsg);
    }
  };

  return (
    <>
      <Modal
        size="lg"
        isOpen={editModal}
        centered
        backdrop="static"
        toggle={toggleEditModal}
        className="edit-modal-card ediOrganizations"
      >
        {/* <ModalHeader tag="h4" toggle={toggleEditModal}></ModalHeader> */}

        <ModalBody>
          <div className="">
            <div className="filters-cards-cross">
              <div className="filter-content">
                <h4> {t(`Organization.SPOC.Update SPOC Details`)} </h4>
              </div>
              <div className="filter-content cross">
                <img
                  src={cross}
                  alt=""
                  onClick={() => {
                    toggleEditModal();
                  }}
                />
              </div>
            </div>
            <Row className="">
              <Col md={12} className="">
                <Form.Group className="mb-2 floating-label">
                  <Form.Label className="float-label">
                    {t(`Organization.SPOC.Name`)}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder={t(`Organization.SPOC.Enter Name`)}
                    type="text"
                    name="name"
                    value={editSPOCDetails?.name}
                    onChange={e => {
                      setEditSPOCDetails({
                        ...editSPOCDetails,
                        name: e.target.value,
                      });
                      setErrors({
                        ...errors,
                        name: !!e?.target?.value?.trim()
                          ? null
                          : t("Organization.SPOC.Name is required"),
                      });

                      setTimeout(() => {
                        setErrors({
                          ...errors,
                          name: null,
                        });
                      }, 2500);
                    }}
                    title={t(`Organization.SPOC.Name`)}
                  />
                  {errors?.name && (
                    <p className="text-danger">{errors?.name}</p>
                  )}
                </Form.Group>
              </Col>

              <Col md={12} className="">
                <Form.Group className="mb-2 floating-label">
                  <Form.Label className="float-label">
                    {t(`Organization.SPOC.Email`)}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder={t(`Organization.SPOC.Enter Email`)}
                    type="email"
                    name="email_id"
                    value={editSPOCDetails?.email_id}
                    onChange={e => {
                      setEditSPOCDetails({
                        ...editSPOCDetails,
                        email_id: e.target.value,
                      });
                      setErrors({
                        ...errors,
                        email_id: !!e?.target?.value?.trim()
                          ? null
                          : t("Organization.SPOC.Email is required"),
                      });

                      setTimeout(() => {
                        setErrors({
                          ...errors,
                          email_id: null,
                        });
                      }, 2500);
                    }}
                    title={t(`Organization.SPOC.Email`)}
                  />
                  {errors?.email_id && (
                    <p className="text-danger">{errors?.email_id}</p>
                  )}
                </Form.Group>
              </Col>

              <Col md={12} className="">
                <Form.Group className="mb-2 floating-label">
                  <Form.Label className="float-label">
                    {t(`Organization.SPOC.Mobile`)}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder={t(`Organization.SPOC.Enter Mobile No`)}
                    type="tel"
                    name="mobile_no"
                    value={editSPOCDetails?.mobile_no}
                    onChange={e => {
                      setEditSPOCDetails({
                        ...editSPOCDetails,
                        mobile_no: e.target.value,
                      });
                      setErrors({
                        ...errors,
                        mobile_no: !!e?.target?.value?.trim()
                          ? null
                          : t("Organization.SPOC.Mobile number is required"),
                      });

                      setTimeout(() => {
                        setErrors({
                          ...errors,
                          mobile_no: null,
                        });
                      }, 2500);
                    }}
                    title={t(`Organization.SPOC.Mobile`)}
                  />
                  {errors?.mobile_no && (
                    <p className="text-danger">{errors?.mobile_no}</p>
                  )}
                </Form.Group>
              </Col>

              <Col md={12} className="">
                <Form.Group className="mb-2 floating-label">
                  <Form.Label className="float-label">
                    {t(`Organization.SPOC.Role`)}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder={t(`Organization.SPOC.Enter Role`)}
                    type="text"
                    name="role"
                    value={editSPOCDetails?.role}
                    onChange={e => {
                      setEditSPOCDetails({
                        ...editSPOCDetails,
                        role: e.target.value,
                      });
                    }}
                    title={t(`Organization.SPOC.Role`)}
                  />
                     {errors?.role && <p className="text-danger">{errors.role}</p>}
                </Form.Group>
              </Col>

              <Col md={12} className="d-flex gap-2 mt-4">
                <button
                  className="btn btn-primary reset"
                  onClick={() => {
                    toggleEditModal();
                  }}
                >
                  {t(`Organization.SPOC.Cancel`)}
                </button>
                <button
                  className="btn btn-primary search"
                  onClick={() => handleSaveClick()}
                >
                  {t(`Organization.SPOC.Update`)}
                </button>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default EditSPOCModal;
